<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import CloseButton from './CloseButton.svelte';
  import i18n from './i18n/i18n';

  /* ____________ Mobile Detection ____________ */
  import UA from "ua-parser-js";
  const ua = new UA();
  let isMobile = ua.getResult().device["type"] == "mobile";

  export let url;
  export let platform = 'instagram';
  export let title;
  export let textColor = '#ffffff';
  export let altText = '';

  const dispatch = createEventDispatcher();

  let closeButtonRef;
  let containerRef;

  function handleClose() {
    dispatch('close');
  }

  function handleKeyDown(e) {
    if (e.key === 'Escape') handleClose();
  }

  function processInstagramEmbed() {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }

  onMount(() => {
    // Load Instagram embed script if not already loaded
    if (!window.instgrm) {
      const script = document.createElement('script');
      script.src = '//www.instagram.com/embed.js';
      document.body.appendChild(script);
    }
  });

  // Watch for URL changes to process the embed
  $: if (url) {
    // Use setTimeout to ensure the DOM has updated
    setTimeout(processInstagramEmbed, 0);
  }
</script>

<div 
  class="popup-overlay" 
  on:click={handleClose}
  on:keydown={handleKeyDown}
  role="dialog"
  aria-modal="true"
  aria-label={altText ? altText : `${platform} embed: ${title || platform}`}
>
  <div class="social-popup">
    <div class="social-content">
      <main class="social-embed-container" bind:this={containerRef}>
          <blockquote 
            class="instagram-media" 
            data-instgrm-captioned 
            data-instgrm-permalink={url}
            data-instgrm-version="14" 
            style="background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"
          >
            <div style="padding:16px;">
              <a 
                href={url} 
                style="background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" 
                target="_blank"
                rel="noopener noreferrer"
              >
                <div style="display: flex; flex-direction: row; align-items: center;">
                  <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div>
                  <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;">
                    <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div>
                    <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div>
                  </div>
                </div>
              </a>
            </div>
          </blockquote>
          {#if altText && altText.trim().length > 0}
            <div class="social-alt-text" role="complementary" aria-label="Description">
              <h4>Description</h4>
              <p>{altText}</p>
            </div>
          {/if}
      </main>
      <div class="close-button-container">
        <CloseButton 
          bind:this={closeButtonRef}
          close={handleClose}
          color={textColor}
          useAbsolutePosition={false}
          marginBottom={isMobile ? '0' : '1rem'}
        />
      </div>
    </div>
  </div>
</div>

<style>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    backdrop-filter: blur(2px);
  }

  .social-popup {
    background-color: transparent;
    width: 600px;
    max-width: 95vw;
    max-height: 95vh;
    margin: auto;
    position: relative;
  }

  .social-content {
    display: flex;
    gap: 0;
    align-items: flex-start;
  }

  .social-embed-container {
    flex: 1;
    padding: 0;
    max-height: 95vh;
    overflow-y: auto;
  }

  .close-button-container {
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    .social-popup {
      width: 100vw;
      max-width: 100vw;
      max-height: 100vh;
    }

    .social-content {
      flex-direction: column-reverse;
      align-items: center;
      gap: 0;
    }

    .social-embed-container {
      width: 90%;
    }

    .close-button-container {
      padding-top: 0;
      align-self: end;
    }

  .social-embed-container {
    padding: 0;
  }
}

.social-alt-text {
  margin-top: 1rem;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  color: #333;
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 540px;
  box-sizing: border-box;
}

.social-alt-text h4 {
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
  font-weight: 600;
}

.social-alt-text p {
  margin: 0;
  white-space: pre-wrap;
}
</style>